module.exports = {
  __depends__: [ require(89) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(81) ],
  elementRegistry: [ 'type', require(83) ],
  elementFactory: [ 'type', require(82) ],
  eventBus: [ 'type', require(84) ],
  graphicsFactory: [ 'type', require(85) ]
};